import { ThunkResult } from "../reducers";
import routes from "../routes/routes";

export const logoutAction = (history: any): ThunkResult => async dispatch => {
  dispatch({ type: "CLEAR_AUTH" });
  history.replace(routes.login);
};
